import React from "react";

export default function FancyDate({ date }: { date: Date }) {
  let months = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];
  let days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
  let today = new Date();
  let tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);
  let yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  function fullDate(d: Date) {
    //console.log(d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear());
    return d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
  }
  return (
    <div className="flex gap-2">
      {fullDate(date) === fullDate(today) && (
        <h1 className="flex-grow text-6xl font-black">Today</h1>
      )}
      {fullDate(date) === fullDate(tomorrow) && (
        <h1 className="flex-grow text-6xl font-black">Tomorrow</h1>
      )}
      {fullDate(date) === fullDate(yesterday) && (
        <h1 className="flex-grow text-6xl font-black">Yesterday</h1>
      )}

      {fullDate(date) !== fullDate(today) &&
        fullDate(date) !== fullDate(tomorrow) &&
        fullDate(date) !== fullDate(yesterday) && (
          <>
            <div className="flex flex-col">
              <div className="mt-[6px] text-center text-3xl font-bold">
                {date.getDate()}
              </div>
              <div className="text-lg font-bold uppercase">
                {months[date.getMonth()]}
              </div>
            </div>
            <div className="text-7xl font-black uppercase">
              {days[date.getDay()]}
            </div>
          </>
        )}
    </div>
  );
}
